export function producaoPedidosAtiva(empresa: any): boolean {
  // Este helper também é usado pelo Angular: não pode carregar Modulo e seus mapeadores.
  const moduloEstoque = {id: 11};
  return !!empresa && (empresa.producaoPedidosAtiva === true || Number(empresa.producaoPedidosAtiva) === 1) &&
    !!(empresa.possuiModulo?.('controle de estoque') || empresa.possuiObjetoModulo?.(moduloEstoque));
}
